import React,{useState,useEffect,useRef} from "react";
import './ReleaseMusic.css'
import UploadMusicIcon from './../../../../images/addmusicicon.png'
import { Trans, useTranslation} from 'react-i18next'
import ProgressBar from "@ramonak/react-progress-bar";
import {useNavigate,useLocation} from "react-router-dom";
import ReactModal from 'react-modal';
import CrossIcon from './../../../../images/crossicon.png'
import { useJwt, decodeToken } from "react-jwt";
import Cookies from "universal-cookie";

function UploadFiles({pagePath,setPagePath,setFiles,files,trackUploaded,setTrackUploaded}) {

    const ref = useRef(null)
    const inputRef = useRef(null)
    const {t, i18n } = useTranslation();
    const addRef = useRef(null)
    const [audiolength,setAudioLength] = useState([])
    const [audioplay,setAudioPlay] = useState([])
    const [dragActive , setDragActive] = useState(false)
    const [trackTimeLeft, setTrackTimeLeft] = useState(null)
    const [errorState,setErrorState] = useState([])
    const [updateFilelist,setUpdateFileList] = useState(0);
    const [deletePopup,setDeletePopup] = useState(false)
    const [deleteTrackIndex,setDeleteTrackIndex] = useState(false)
    const navigate = useNavigate();
    const cookies = new Cookies(null ,{ path: '/' });
    const location = useLocation();

    function closeDeletePopup(){ 
        setDeletePopup(false)
      }
  

    function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      }

    useEffect(()=>{
        topFunction()
        // setHeight(ref.current.clientHeight)
        console.log("Files Global")

        if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
           setPagePath("/Dashboard/releasemusic/uploadtracks")
        }

        if(decodeToken(cookies.get('token')).info.role==="label"){
           setPagePath("/dashboard/label/releasemusic/uploadtracks")
        }
    },[])

    useEffect(()=>{
        // if(files.length!==0){
        //     setFiles(files)
        // }
        // if(files.length===0){
        //     setTrackUploaded(false)
        // }
    },[files])

    useEffect(()=>{

    },[updateFilelist])


    useEffect(()=>{
        console.log("Trackuploaded changed")
        console.log(trackUploaded)
    },[trackUploaded])
   

    useEffect(() => {
        // exit early when we reach 0
        if (!trackTimeLeft) return;
    
        if(trackTimeLeft===1){
          console.log("TIME LEFT IS 1");
          setTrackUploaded(true)
        }
    
        if(trackTimeLeft===0){
           console.log("TIME LEFT IS 0");
        }
    
        // save intervalId to clear the interval when the
        // component re-renders
        const intervalId = setInterval(() => {
    
          setTrackTimeLeft(trackTimeLeft - 1);
        }, 1000);
      // clear interval on re-render to avoid memory leaks
      return () => clearInterval(intervalId);
      // add timeLeft as a dependency to re-rerun the effect
      // when we update it
    }, [trackTimeLeft]);

    {/** Progress bar */}
    const Progress = ({done}) => {
        const [style, setStyle] = React.useState({});
        
        setTimeout(() => {
        const newStyle = {
            opacity: 1,
            width: `${done}%`
        }
        
        setStyle(newStyle);
        }, 200);
        
        return (
        <div className="progress">
            <div className="progress-done" style={style}>
            {done}%
            </div>
        </div>
        )
    }

    {/*Delete Song*/} 
    const deletesong =  (songid) =>{
        setFiles(files.filter((file,index)=>{
          console.log("^^^^^^^^^^^")
          console.log(file)
          console.log(songid)
          console.log(index)
          return index!==songid
        })
        )
        setAudioLength(audiolength.filter((file,index)=>{
          return index!==songid
        }))
    }


     {/** Drag drop funtions */}
     const handleDrag = (e) =>{
        e.preventDefault();
        e.stopPropagation();

        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
          } else if (e.type === "dragleave") {
            setDragActive(false);
          }
    }

    const handleChange = (e) => {
        e.preventDefault();
        if (e.target.files && e.target.files[0]) {
          const filelist = []
          const error =[]
          for(var i=0;i<e.target.files.length;i++){
        
            // filelist.push(e.target.files[i])
            error.push(e.target.files[i].type!=="audio/wav")
            if(e.target.files[i].type==="audio/mpeg" || e.target.files[i].type==="audio/wav"){
          //   filelist.push({
          //     "Asset_id":null,
          //     "Trackname":"",
          //     "Asset_file":e.target.files[i],
          //     "Producers":[],
          //     "ProducerIds":[],
          //     "Songwriters":[],
          //     "SongwriterIds":[],
          //     "FeaturedArtist":[],
          //     "FeaturedArtistIds":[],
          //     "ExplicitContent":"",
          //     "Price":0.99,
          //     "Language":"",
          //     "RadioEdit":"",
          //     "Collaborators":[],
          //     "CollaboratorIds":[],
          //     "IsCollaborator":false,
          //     "isDragging":false,
          //     "isPlaying":false
          // })
          filelist.push({
            "Asset_id":null,
            "Tracktitle":"",
            "Asset_file":e.target.files[i],
            "Arists":[],
            "ArtistIds":[],
            "Contributors":[],
            "ContributorIds":[],
            "Publishers":[],
            "PublisherIds":[],
            "Lyrics":"",
            "AudioLanguage":"",
            "MetadataLanguage":"",
            "ExplicitContent":"",
            "Collaborators":[],
            "CollaboratorIds":[],
            "IsCollaborator":false,
            "isDragging":false,
            "isPlaying":false
        })
        }
          }

          setFiles(filelist)
          setErrorState(error)
          setTrackTimeLeft(3)
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
          var filelist=[]
          var error=[]
          for(var i=0;i<e.dataTransfer.files.length;i++){
            console.log(e.dataTransfer.files[i].type!=="audio/wav")
            error.push(e.dataTransfer.files[i].type!=="audio/wav")
            // console.log()
            if(e.dataTransfer.files[i].type==="audio/mpeg" || e.dataTransfer.files[i].type==="audio/wav"){
              filelist.push({
                "Asset_id":null,
                "Tracktitle":"",
                "Asset_file":e.dataTransfer.files[i],
                "Arists":[],
                "ArtistIds":[],
                "Contributors":[],
                "ContributorIds":[],
                "Publishers":[],
                "PublisherIds":[],
                "Lyrics":"",
                "AudioLanguage":"",
                "MetadataLanguage":"",
                "ExplicitContent":"",
                "Collaborators":[],
                "CollaboratorIds":[],
                "IsCollaborator":false,
                "isDragging":false,
                "isPlaying":false
            })
            }
           
          
          }
          setFiles(filelist)
          setErrorState(error)
          setTrackTimeLeft(3)
        }
    };

    const handleAdd = (e) => {
        e.preventDefault();
        console.log("Fired")
          const filelist = files
          console.log(filelist)
          for(var i=0;i<e.target.files.length;i++){
            // filelist.push(e.target.files[i])
            if(e.target.files[i].type==="audio/mpeg" || e.target.files[i].type==="audio/wav"){
          //   filelist.push({
          //     "Asset_id":null,
          //     "Trackname":"",
          //     "Asset_file":e.target.files[i],
          //     "Producers":[],
          //     "ProducerIds":[],
          //     "Songwriters":[],
          //     "SongwriterIds":[],
          //      "FeaturedArtist":[],
          //     "FeaturedArtistIds":[],
          //       "ExplicitContent":"",
          //       "Price":0.99,
          //       "Language":"",
          //       "RadioEdit":"",
          //       "Collaborators":[],
          //       "CollaboratorIds":[],
          //       "IsCollaborator":false,
          //       "isDragging":false,
          //       "isPlaying":false
          // })
          filelist.push({
            "Asset_id":null,
            "Tracktitle":"",
            "Asset_file":e.target.files[i],
            "Arists":[],
            "ArtistIds":[],
            "Contributors":[],
            "ContributorIds":[],
            "Publishers":[],
            "PublisherIds":[],
            "Lyrics":"",
            "AudioLanguage":"",
            "MetadataLanguage":"",
            "ExplicitContent":"",
            "Collaborators":[],
            "CollaboratorIds":[],
            "IsCollaborator":false,
            "isDragging":false,
            "isPlaying":false
        })
        }
          }
          console.log(filelist)
          setFiles(filelist)
          setUpdateFileList(Math.random())
          console.log(files)
    };

    const onAddTrackClick = () => {
        addRef.current.click();
    };
  

    const onButtonClick = () => {
        inputRef.current.click();
    };
    
    return (
        <div>
            {
                files.length==0 &&
                <div style={{display:'flex',flexDirection:'column',alignItems:"center"}} ref={ref}>
                    

                <div className="AddMusicHeader">{t('Addyourmusic')}</div>
                <div className="AddMusicDesc"> <Trans i18nKey="Forbeststreaming" components={{1:<br/>}} >
                For best streaming and download, we recommend 16-bit, 441kHz<br/> Stereo wav files
                            </Trans></div> 

            
                <form id="form-file-upload" style={{cursor:'pointer'}} onDragEnter={handleDrag} onSubmit={(e) => e.preventDefault()}>
                    <input ref={inputRef} type="file" id="input-file-upload" multiple={true} onChange={handleChange} accept="audio/*"/>
                    <label id="label-file-upload" htmlFor="input-file-upload" className={dragActive ? "drag-active" : "" }>
                    
                        <img src={UploadMusicIcon} alt="Drag or Drop music Icon" className="UploadImageIcon"/>
                            <span className="DragDropText"><Trans i18nKey="Dragordrop" components={{1:<br/>}} >
                            Drag and Drop your files here <br/> or 
                            </Trans>
                                <button className="upload-button" onClick={onButtonClick} style={{color:'#C7A5FF',textDecoration:'underline'}}>
                                {t('Browseyourfiles')} 
                                </button>
                            </span>
                        
                    </label>

                    { dragActive && <div id="drag-file-element" onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}></div> }
                </form>
                </div>
            }

            {
                files.length!==0 && !trackUploaded &&
                <div style={{display:'flex',flexDirection:'column',alignItems:"center"}} ref={ref}>
                
                
                <div className="AddMusicHeader">{t('Uploading')}</div>
            
                <div className="AddMusicDesc">{t('Pleasewaitwhilewe')}</div>
                
            
                <div className="UploadContainer">
                    {
                    files.map((file,index)=>{
                    
                        return (
                        <div style={{display:'flex',flexDirection:'row',marginTop:'1.75em',width:'85%',justifyContent:'space-between'}}> 
                            <div style={{display:'flex',flexDirection:'column'}}>
                                <div className="FileName">
                                {file.Asset_file.name}
                                </div>
                                <Progress done="100" />
                                {/* <ProgressBar completed={0} maxCompleted={100} className="progressWrapper" labelClassName="progressLabel" barContainerClassName="progressContainer" completedClassName="barCompleted"/> */}
                            </div>
                            <div className="CancelTxt" onClick={()=>deletesong(index)}>
                            {t('Cancel')}
                            </div>
                        </div>
                        )
                    })
                    }
                </div>

                {
                files.length!==0 && !trackUploaded &&
                <div className="ContinueButton" style={{backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
                {t('ContinueRelease')}
                </div> 
                }
            

                

                </div>
            }

            {
                files.length!==0 && trackUploaded &&
                <div style={{display:'flex',flexDirection:'column',alignItems:"center"}} ref={ref}>
                

                <div className="AddMusicHeader">Uploaded</div>
            
                <div className="AddMusicDesc">Add more files or continue</div>
                
            
                <div className="UploadContainer">
                    {
                    
                    files.map((file,index)=>{
                        
                        const Audio = () => {
                        const audioRef = useRef();
                    
                        const onLoadedMetadata = () => {
                            if (audioRef.current) {
                                
                                function fancyTimeFormat(duration) {
                                    // Hours, minutes and seconds
                                    const hrs = Math.floor(duration / 3600);
                                    const mins = Math.floor((duration % 3600) / 60);
                                    const secs = Math.floor(duration) % 60;
                                
                                    // Output like "1:01" or "4:03:59" or "123:03:59"
                                    let ret = "";
                                
                                    if (hrs > 0) {
                                    ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
                                    }
                                
                                    ret += "" + mins + ":" + (secs < 10 ? "0" : "");
                                    ret += "" + secs;
                                
                                    return ret;
                                }
                                audiolength[index] =fancyTimeFormat(audioRef.current.duration)
                                setUpdateFileList(Math.random())
                                // audiolength[index] = ("").concat(Math.floor(audioRef.current.duration / 60)).concat(":").concat(Math.floor(audioRef.current.duration - Math.floor(audioRef.current.duration / 60)*60).toFixed(0))
                            }
                        };
                        {/* <source src={URL.createObjectURL(file)} type="audio/wav" /> */}
                        return (
                            <audio
                                ref={audioRef}
                                onLoadedMetadata={onLoadedMetadata}
                                src={URL.createObjectURL(file.Asset_file)}
                            />
                                
                            
                        );
                    };

                        
                        return (
                        <div style={{display:'flex',flexDirection:'row',marginTop:'1.75em',width:'85%',justifyContent:'space-between'}}> 
                        
                        

                            <div className="FileName" style={{width:'55%'}}>
                            {index+1}.&nbsp;{file.Asset_file.name}
                            </div>
                            
                            <Audio
                                
                            />

                            <div className="FileName">
                            {audiolength[index]}
                            </div>

                            
                            <div className="CancelTxt" onClick={()=>{setDeletePopup(true);setDeleteTrackIndex(index)}}>
                            Remove
                            </div>
                        </div>
                        )
                    })
                    }
            
                <form id="form-file-upload4" style={{cursor:'pointer',alignSelf:'flex-start',marginLeft:'2em',marginBottom:'1em',display:'flex'}}  onSubmit={(e) => e.preventDefault()}>
                            <input ref={addRef} type="file" id="input-file-upload" multiple={true} onChange={handleAdd} accept=".wav"/>
                            <label id="label-file-upload" htmlFor="input-file-upload" className={dragActive ? "drag-active" : "" }>
                                
                                
                                    <span className="Addmorebtn" style={{marginBottom:'0em',fontSize:'1rem'}}>
                            
                                        <button className="upload-button" onClick={onAddTrackClick} style={{color:'#C7A5FF'}}>
                                        + Add more
                                        </button>
                                    </span>
                                
                            </label>

                            {/* { dragActive && <div id="drag-file-element" onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}></div> } */}
                        </form>

                    
                </div>

                <div className="ContinueButton" onClick={()=>{
                    if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
                        navigate("/Dashboard/releasemusic/uploadphoto")
                      }
            
                      if(decodeToken(cookies.get('token')).info.role==="label"){
                        navigate("/dashboard/label/releasemusic/uploadphoto")
                      }
                        }}>
                {t('ContinueRelease')}
                <div className="PostLoginBtnOverlay"/>
                </div> 

                

                </div>
            }

            <ReactModal
                            isOpen={deletePopup}
                            overlayClassName="Overlay"
                            contentLabel="Example Modal"
                            onRequestClose={closeDeletePopup} // closes the modal when the user presses the escape key
                            shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
                            style={{ 
                                content:{
                                width:'32.18em',
                                height:'12.68em',
                                margin:'auto',
                                backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
                                display:'flex',
                                flexDirection:'column',
                                alignItems:'center',
                                borderRadius:'8px',
                                border:'0.5px solid rgba(255,255,255,25%)'
                                }
                            }}
                            >
                                
                                <div className="popupheaderinfo">Remove?</div>
                                    <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em',cursor:'pointer'}} onClick={()=>{setDeletePopup(false)}}/>
                                   

                                

                                    <span className="SettingPopupH3" style={{width:'80%',marginTop:'2em',marginLeft:'-1.6em'}}>Do you want to remove this item from the list?</span>
                                   
                                   
                                   
                                    <div style={{display:'flex',flexDirection:'row',marginTop:'1em'}}>
                                        <div className="GoBackBtn" style={{paddingTop:'0.75em',paddingBottom:'0.5em',marginRight:'1em',cursor:'pointer'}} onClick={()=>{setDeletePopup(false)}}>
                                            Cancel
                                        </div>

                                        <div className="IUnderstandBtn" style={{height:'3em',cursor:'pointer'}} onClick={()=>{deletesong(deleteTrackIndex);setDeletePopup(false)}}>
                                            Yes, Remove
                                            <div className="PostLoginBtnOverlay"/>
                                        </div>
                                    </div>
            </ReactModal>

        </div>
        
    );
}

export default UploadFiles;